"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Colors = void 0;
const primary = '#436eac';
exports.Colors = {
    background: '#F2F2F2',
    ///////////////////////////////////////////
    primary,
    lightgrey: '#F2F2F2',
    /** @deprecated Use Colors.background */
    backgroundColor: '#F2F2F2',
    white: 'rgb(255,255,255)',
    black: '#4F4F4F',
    blue: '#2B6497',
    green: '#00c853',
    lightBlue: '#F2F7FA',
    border: '#DBDBDB',
    card: '#fefefe',
    darkGray: '#9E9E9E',
    disabled: '#949494',
    error: '#B00020',
    gray: 'rgb(109,110,113)',
    icon: primary,
    midGray: '#BDBDBD',
    red: '#c00000',
    secondary: '#F15A22',
    text: '#000',
    tintColor: '#2f95dc',
    title: 'rgb(125,125,125)',
    label: 'rgb(110,110,110)',
    placeholder: 'rgba(0,0,0,0.54)',
    description: 'rgba(0, 0, 0, 0.54)',
};
